module.exports = __webpack_public_path__ + "static/media/us4.0.ad8f3dec.png";